import { composeModule } from '@opengov/compose-app';

export const { composeStateMachine, composeEffects, composeMiddleware, composeSubscriber, exportModule, namespace } =
  composeModule('reporting-legacy-compose', 'na');
